import React from "react";
import { StationIssue } from "@shared/models";
import { TableProperty } from "@shared/components/Table/interfaces";
import { StationIssueRowComponent } from "@containers/Station/components/StationIssuesListContainer";

export const stationIssuesTableProperties = (
  onClickMarkAsRead: (issue: StationIssue) => void,
  onOpen: (issue: StationIssue) => void,
): TableProperty<StationIssue>[] => [
  {
    key: "id",
    title: "",
    get: (item) => {
      return <StationIssueRowComponent item={item} onClickMarkAsRead={onClickMarkAsRead} onOpen={onOpen} />;
    },
  },
];
